module.exports = __webpack_public_path__ + "img/cursor.72f08e8.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/cursor.png
// module id = gdZi
// module chunks = 33